import { IActionReducer } from 'redhotpie-shared-lib/interfaces/IUtils';
import initialState from './initialState';
import {
  INIT_MEDIA_UPLOADING_STATE_REPORT,
  RESET_MEDIA_UPLOADING_STATE_REPORT,
  UPDATE_MEDIA_UPLOADING_STATE_REPORT,
} from 'redhotpie-shared-lib/constants/actionTypes';
// @ts-ignore
import Immutable from 'seamless-immutable';

export default function reportReducer(state = initialState.reportState, action: IActionReducer) {
  switch (action.type) {
    case RESET_MEDIA_UPLOADING_STATE_REPORT: {
      return state.merge({
        mediaReportUploading: {
          pendingUploadingCount: 0,
          pendingUploadingPhotoIds: [],
          pendingUploadingVideoIds: [],
          pendingUploadingMediaIds: [],
          isHaveVideoUploading: false,
          isHavePhotoUploading: false,
          isHaveMediaUploading: false,
        },
      });
    }
    case INIT_MEDIA_UPLOADING_STATE_REPORT: {
      const { mediaReportUploading } = Immutable.asMutable(state);
      return state.merge({ mediaReportUploading: { ...mediaReportUploading, ...action.data } });
    }
    case UPDATE_MEDIA_UPLOADING_STATE_REPORT: {
      const { mediaReportUploading } = state;
      const _mediaReportUploading: any = mediaReportUploading.asMutable({ deep: true });
      const id = action.params.id;
      const isVideo = id?.includes('video');
      const isUploading = action.params.isUploading;
      const isFinished = action.params.isFinished;
      let item = _mediaReportUploading[id] || undefined;
      if (item) {
        _mediaReportUploading[id] = { ...item, ...action.params };
      }

      if (isUploading) {
        if (isVideo) {
          _mediaReportUploading.isHaveVideoUploading = true;
        }
        if (isVideo) {
          _mediaReportUploading.pendingUploadingVideoIds = _mediaReportUploading.pendingUploadingVideoIds.filter(
            (_id: string) => _id !== id
          );
        } else {
          _mediaReportUploading.pendingUploadingPhotoIds = _mediaReportUploading.pendingUploadingPhotoIds.filter(
            (_id: string) => _id !== id
          );
          _mediaReportUploading.isHavePhotoUploading = true;
        }
        _mediaReportUploading.pendingUploadingMediaIds = _mediaReportUploading.pendingUploadingMediaIds.filter((_id: string) => _id !== id);
        _mediaReportUploading.isHaveMediaUploading = true;
      }
      if (isFinished) {
        _mediaReportUploading.pendingUploadingCount = _mediaReportUploading.pendingUploadingCount - 1;

        if (isVideo) {
          _mediaReportUploading.isHaveVideoUploading = false;
        } else {
          _mediaReportUploading.isHavePhotoUploading = false;
        }
        _mediaReportUploading.isHaveMediaUploading = false;
      }
      return state.merge({ mediaReportUploading: _mediaReportUploading });
    }
    default:
      return state;
  }
}
